"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Keep track of open popup windows so we only have one open at a time.
 *
 * @type {Object}
 */
var openPopup;
var openModal;
var closeInterval;

/**
 * Closes previously opened windows and modals.
 */
function closeAll() {
  if (openPopup) {
    openPopup.close();
  }
  if (openModal) {
    openModal.close();
  }
  openPopup = null;
  openModal = null;
  clearInterval(closeInterval);
}

/**
 * Pop open an authentication window. It adds some additional safe guards such
 * as catching blocked popup windows, listening for window closes, simplified
 * window positioning, etc.
 *
 * @return {Object} Execute `close` when the window is safe to cleared.
 */
module.exports = function (url, cb) {
  var width = Math.min(720, window.screen.availWidth);
  var height = Math.min(480, window.screen.availHeight);
  var top = Math.min(100, (window.screen.availHeight - height) / 2);
  var left = (window.screen.availWidth - width) / 2;
  function done(err) {
    closeAll();
    cb(err);
  }

  // Close previously open popup windows and modals.
  closeAll();

  // Open a popup window when the authentication button is pressed.
  openPopup = window.open(url, '', ["top=".concat(top), "left=".concat(left), "width=".concat(width), "height=".concat(height), 'scrollbars=1'].join(','));
  if (_typeof(openPopup) !== 'object') {
    openPopup = null;
    done(new Error('Popup window blocked'));
  }

  // Catch window closes before authentication is complete.
  closeInterval = setInterval(function () {
    if (openPopup.closed) {
      openPopup = null;
      done(new Error('Popup window closed'));
    }
  }, 400);
  return {
    close: function close() {
      // Remove any references to open modals and windows.
      return closeAll();
    }
  };
};
//# sourceMappingURL=authWindow.js.map